import React from 'react'
import PropTypes from 'prop-types'
import { Input } from './styled'

const TextAreaInputView = React.forwardRef(({ 
  value, 
  onChange, 
  label, 
  error, 
  className, 
  type, 
  ...props 
}, ref) => {
  const handleChange = event => {
    onChange(event)
  }
  
  return (
    <Input
      label={label}
      value={value}
      variant='filled'
      error={error}
      type={type}
      onChange={event => handleChange(event)}
      helperText={error?.message}
      className={className}
      ref={ref}
      {...props}
    />
  )
})

TextAreaInputView.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
}

TextAreaInputView.defaultProps = {
  label: '',
  value: '',
  onChange: () => null,
  error: null,
  className: '',
  type: 'text',
}

// Add a display name for better debugging
TextAreaInputView.displayName = 'TextAreaInputView'

export default TextAreaInputView